<template>
  <div >
      <div class="zoom">
        <div
          :class="'zoom-out' + (nowVal === 50 ? ' disabled' : '')"
          @click="zoomSize(1)"
        >
          <i class="el-icon-minus" />
        </div>
        <span>{{ nowVal }}%</span>
        <div
          :class="'zoom-in' + (nowVal === 200 ? ' disabled' : '')"
          @click="zoomSize(2)"
        >
          <i class="el-icon-plus" />
        </div>
      </div>
      <flowHelper :isDisabled="$attrs.isDisabled" />
      <div
        :style="
          'transform: scale(' +
          nowVal / 100 +
          '); transform-origin: 50% 0px 0px;'
        "
        class="box-scale"
      >
        <taskflow :isDisabled="$attrs.isDisabled" />
      </div>
  </div>
</template>

<script>
import taskflow from './taskflow'
import flowHelper from './flowHelper'

export default {
  name: 'approvalConfig',
  data() {
    return {
      nowVal: 100,
    }
  },
  components: {
    taskflow,
    flowHelper,
  },
  methods: {
    zoomSize(type) {
      if (type === 1) {
        if (this.nowVal === 50) return
        this.nowVal -= 10
      } else {
        if (this.nowVal === 200) return
        this.nowVal += 10
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.zoom {
  position: absolute;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 32px;
  width: 125px;
  right: 16px;
  z-index: 10;
  margin-top: 20px;
}
.zoom .zoom-in,
.zoom .zoom-out {
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #fff;
  color: #323233;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid #dcdee0;
  text-align: center;
  font-size: 16px;
}
.zoom .zoom-out.disabled,
.zoom-in.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
